import { useEffect, useState } from 'react';

export const useNotifications = (_notifications) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadNotifications, setUnreadNotifications] = useState([]);

  useEffect(() => {
    if (Array.isArray(_notifications)) {
      setNotifications(_notifications);
    }
  }, [_notifications]);

  useEffect(() => {
    const unreads = notifications.filter((notification) => !notification.read);
    setUnreadNotifications(unreads);
  }, [notifications]);

  return {
    notifications,
    unreadNotifications,
    setNotifications
  };
};

// Example Usage:

// import React, { useEffect } from 'react';
// import { useNotifications } from './useNotifications';
// 
// function NotificationComponent() {
//   const { notifications, unreadNotifications, setNotifications } = useNotifications([]);
// 
//   useEffect(() => {
//     // Fetch notifications from an API or other source
//     const fetchedNotifications = [
//       { id: 1, read: false, message: 'New message 1' },
//       { id: 2, read: true, message: 'New message 2' },
//       // More notifications...
//     ];
// 
//     setNotifications(fetchedNotifications);
//   }, []);
// 
//   return (
//     <div>
//       <h1>You have {unreadNotifications.length} unread notifications</h1>
//       {notifications.map((notification) => (
//         <p key={notification.id}>{notification.message}</p>
//       ))}
//     </div>
//   );
// }
// 
// export default NotificationComponent;